import React from 'react';
import ClockState from '../States/ClockStates';

export function FormattedDate(props: ClockState) {
	return <h2>It is {props.date.toLocaleTimeString()}.</h2>;
}
